export default __webpack_public_path__ + "static/media/arrow_right-white.fdcf02e6.svg";